export class ObjectHelper {
    static get<T extends object>(obj: T, key: string): unknown {
        return (obj as Record<string, unknown>)[key];
    }

    static set<T extends object>(obj: T, key: string, value: unknown): void {
        (obj as Record<string, unknown>)[key] = value;
    }
}
